import { render } from "./failureRateYear.vue?vue&type=template&id=189ec2a2&scoped=true"
import script from "./failureRateYear.vue?vue&type=script&lang=js"
export * from "./failureRateYear.vue?vue&type=script&lang=js"

import "./failureRateYear.vue?vue&type=style&index=0&id=189ec2a2&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189ec2a2"]])

export default __exports__